import React, { useState } from 'react';
import AccountContainer from '../../../../components/AccountContainer';
import Card from '../../../../components/Card';
import ArrowBack from '../../../../assets/icons/arrow-back-icon.svg';
import FindSingleFlight from './FindSingleFlight';
import FlightResults from './FlightResults';
import { useIntl } from 'react-intl';
import messages from '../messages';
import { useTranslatedNavigate } from '../../../../utils/routes';
import { useJsonApi } from '../../../../services/GlobalStore/GlobalStore';
import useAuthenticate from '../../../../hooks/useAuthenticate';
import translations from '../../../../translations/main.json';

const EnterManualFlights = () => {
  const [isReturnFlight, setIsReturnFlight] = useState(false);
  const [isFlightPage, setIsFlightPage] = useState(false);
  const [departureFlight, setDepartureFlight] = useState({});
  const [returnFlight, setReturnFlight] = useState({});
  const [tripId, setTripId] = useState();
  const [tripsArray, setTripsArray] = useState([]);
  const { formatMessage } = useIntl();
  const translatedNavigate = useTranslatedNavigate();
  const { token } = useAuthenticate();

  const { data: subscription, loading: subscriptionLoading } = useJsonApi(
    `/subscriptions`,
    {
      cachePolicy: 'no-cache',
      headers: { Authorization: `Bearer ${token}` },
    },
    []
  );

  if (subscription?.[0]?.stripe_status !== 'active' && !subscriptionLoading) {
    translatedNavigate(
      '/' +
        translations['cc4.seo.route.account'] +
        '/' +
        translations['cc4.seo.route.my-premium']
    );
  }

  const handleBack = () => {
    if (isFlightPage || isReturnFlight) {
      setIsFlightPage(false);
      setIsReturnFlight(false);
    } else {
      translatedNavigate(
        '/' +
          translations['cc4.seo.route.account'] +
          '/' +
          translations['cc4.seo.route.my-premium']
      );
    }
  };

  return (
    <>
      {subscription?.[0]?.stripe_status === 'active' ? (
        <AccountContainer>
          <Card style={cardStyles}>
            <div className="select-trip-container">
              <div className="select-trip-header">
                <div className="select-trip-back" onClick={handleBack}>
                  <img
                    src={ArrowBack}
                    alt=""
                    width={6}
                    height={12}
                    style={{ marginLeft: '4px' }}
                  />
                  <span>{formatMessage(messages.backButton)}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {isFlightPage ? (
                    <span className="select-trip-main-header">
                      {formatMessage(messages.confirmTitle)}
                    </span>
                  ) : isReturnFlight ? (
                    <span className="select-trip-main-header">
                      {formatMessage(messages.manualEntryTitle)}
                    </span>
                  ) : (
                    <span className="select-trip-main-header">
                      {formatMessage(messages.manualEntryDepartureTitle)}
                    </span>
                  )}
                  {!isFlightPage ? (
                    <span className="select-trip-main-subheader">
                      {formatMessage(messages.manualEntrySubTitle)}
                    </span>
                  ) : (
                    <span className="select-trip-main-subheader">
                      {formatMessage(messages.confirmSubTitle)}
                    </span>
                  )}
                </div>
              </div>
              {isFlightPage ? (
                <FlightResults
                  departureFlight={departureFlight}
                  returnFlight={returnFlight}
                  tripId={tripId}
                  tripsArray={tripsArray}
                />
              ) : (
                <FindSingleFlight
                  setIsReturnFlight={setIsReturnFlight}
                  isReturnFlight={isReturnFlight}
                  setIsFlightPage={setIsFlightPage}
                  setReturnFlight={setReturnFlight}
                  setDepartureFlight={setDepartureFlight}
                  departureFlight={departureFlight}
                  setTripId={setTripId}
                  setTripsArray={setTripsArray}
                  tripId={tripId}
                  tripsArray={tripsArray}
                />
              )}
            </div>
          </Card>
        </AccountContainer>
      ) : null}
    </>
  );
};

export default EnterManualFlights;

const cardStyles = {
  borderRadius: '12px',
  boxShadow: '0px 4px 8px 0px #D8D8DA',
};
